module.exports = __webpack_public_path__ + "img/tenant-logo.d54d6209.png";